/**
 * Register Service Worker for PWA functionality
 */
import { logger } from "@/utils/logger";

export const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
      });

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker available, show update prompt
              logger.info('New service worker available!');
            }
          });
        }
      });

      logger.info('Service Worker registered successfully');
    } catch (error) {
      logger.error('Service Worker registration failed:', error);
    }
  }
};
